<vs-app-page *ngIf="page" [config]="page">
  <vs-breadcrumbs
    *ngIf="!page.isSubPage"
    slot="breadcrumbs"
    [config]="{ items: [{ label: page.title }] }"
  ></vs-breadcrumbs>

  <ng-container *vsLet="table.dataSource.meta$ | async as meta" slot="title-end">
    <vs-badge
      *vsLet="(meta?.totalItems ?? null) as totalItems"
      class="-mb-1.5"
      [class.italic]="totalItems === null"
      [class.animate-pulse]="totalItems === null"
    >
      {{ totalItems === null ? 'loading' : (totalItems | number) + ' item' + (totalItems === 1 ? '' : 's') }}
    </vs-badge>
  </ng-container>

  <ng-content></ng-content>
  <ng-content select="[slot='before-table']"></ng-content>

  <vs-connected-table
    #table
    [endpoint]="endpoint"
    [columns]="columns ?? []"
    [queryParams]="queryParams ?? null"
    [forceClickableState]="isListeningToRowClicked ? 'clickable' : 'not-clickable'"
    (rowClicked)="rowClicked.emit($event)"
  >
    <ng-content slot="first-load" select="[slot='first-load']"></ng-content>
    <ng-content slot="empty" select="[slot='empty']"></ng-content>
    <ng-content slot="error" select="[slot='error']"></ng-content>
  </vs-connected-table>

  <ng-content select="[slot='after-table']"></ng-content>

  <ng-content slot="before-description" select="[slot='before-description']"></ng-content>
  <ng-content slot="breadcrumbs" select="[slot='breadcrumbs']"></ng-content>
  <ng-content slot="header-end" select="[slot='header-end']"></ng-content>
  <ng-content slot="title-end" select="[slot='title-end']"></ng-content>
  <ng-content slot="sticky" select="[slot='sticky']"></ng-content>
</vs-app-page>
